module.exports = {
  apiurl: "https://cjm.cloud.olym.co.kr/api",
  // apiurl: "http://192.168.1.87:3000"
  // apiurl: "http://localhost:3000"

  trans: {
    "class": { "kor": "클래스", "eng": "Class" },
    "cant_sold": { "kor": "판매불가", "eng": "Can't be sold" },
    "combine_off": { "kor": "조합식 끄기", "eng": "Off Combine" },
    "combine_on": { "kor": "조합식 보기", "eng": "On Combine" },
    "monster": { "kor": "몬스터", "eng": "Monster" },
    "item": { "kor": "아이템", "eng": "Item" },
    "item_select": { "kor": "아이템 선택", "eng": "Item select" },
    "item_search": { "kor": "아이템 검색", "eng": "Item search" },
    "item_important_off": { "kor": "아이템 중요도 설명 접기", "eng": "Off Item importance description" },
    "item_important_on": { "kor": "아이템 중요도 설명 보기", "eng": "On Item importance description" },
    "item_important_1": { "kor": "지나가는 정도로 필요한 수준", "eng": "Levels necessary for passing through" },
    "item_important_2": { "kor": "맵 진행에 어느정도 필요한 수준", "eng": "Levels necessary for progressing through the map" },
    "item_important_3": { "kor": "있으면 진행이 편해지는 수준", "eng": "Levels that make progress easier if you have them" },
    "item_important_4": { "kor": "특수한 상황에서 꼭 필요한 수준", "eng": "Levels absolutely necessary in special situations" },
    "item_important_5": { "kor": "지구가 반쪽이 나도 만들어야 하는 수준", "eng": "Levels that must be made even if the Earth is split in half" },
    "sort_eff_on": { "kor": "가격효율 순으로 보기", "eng": "Sort by efficiency" },
    "sort_general": { "kor": "일반 순으로 보기", "eng": "Sort by normal" },
    "logout": { "kor": "로그아웃", "eng": "Logout" },
    "login": { "kor": "로그인", "eng": "Login" },
    "back": { "kor": "뒤로가기", "eng": "Back" },
    "combine_sick": { "kor": "조합 식", "eng": "Combines" },
    "search": { "kor": "검색", "eng": "search" },
    "ea": { "kor": "개수", "eng": "ea" },
    "order_change": { "kor": "순서변경", "eng": "order change" },
    "control": { "kor": "제어", "eng": "control" },
    "drop_rate_p": { "kor": "드롭률(%)", "eng": "Drop rate(%)" },
    "drop_item": { "kor": "드롭 아이템", "eng": "Drop Item" },
    "search_placeholder": { "kor": "검색어를 입력하세요.", "eng": "Enter search term" },
    "prev": { "kor": "이전", "eng": "Prev" },
    "next": { "kor": "다음", "eng": "Next" },
    "trait": { "kor": "특성", "eng": "Trait" },
    "exp_table": { "kor": "경험치 표", "eng": "Exp Table" },
    "open_all": { "kor": "전부 열기", "eng": "Open All" },
    "close_all": { "kor": "전부 닫기", "eng": "Close All" },
    "open_cal": { "kor": "계산기 열기", "eng": "Open Calculator" },
    "close_cal": { "kor": "계산기 접기", "eng": "Close Calculator" },
    "cal_explain": { "kor": "※모험가의 현재 정보를 설정하고 [계산하기]를 누르면 결과가 나타납니다.", "eng": "※Set the adventurer's current information and click [Calculate] to see the results." },
    "tier": { "kor": "티어", "eng": "Tier" },
    "level": { "kor": "레벨", "eng": "Level" },
    "current_exp": { "kor": "현재 경험치", "eng": "Current EXP" },
    "exp_per_hour": { "kor": "획득 경험치/h", "eng": "EXP per hour" },
    "exp_per_hour2": { "kor": "시간당 획득 경험치", "eng": "EXP per hour" },
    "target_tier": { "kor": "목표 티어", "eng": "Target Tier" },
    "target_level": { "kor": "목표 레벨", "eng": "Target Level" },
    "calculate": { "kor": "계산하기", "eng": "Calculate" },
    "calculating": { "kor": "계산중...", "eng": "Calculating..." },
    "need_exp": { "kor": "필요 경험치", "eng": "Need EXP" },
    "need_time": { "kor": "필요 시간", "eng": "Need Time" },
    "expected_date_time": { "kor": "예상 일시", "eng": "Expected DateTime" },
    "reached_exp": { "kor": "도달 경험치", "eng": "Reached EXP" },
    "cumulative_exp": { "kor": "누적 경험치", "eng": "Cumulative EXP" },
    "exp": { "kor": "경험치", "eng": "EXP" },
    "pet_exp_table_explain": { "kor": "※레벨을 직접 입력하거나 파란 셀을 클릭해서 넣을 수 있습니다.", "eng": "※You can enter the level directly or click on the blue cell to enter it." },
    "pet_merge_explain": { "kor": "※먹일 펫에 투자된 총 경험치의 80%가 대상 펫에 합성됩니다.", "eng": "※80% of the total EXP invested in the pet to be fed will be synthesized into the target pet." },
    "target_pet": { "kor": "대상 펫", "eng": "Target Pet" },
    "merging_pet": { "kor": "먹일 펫", "eng": "Merging Pet" },
    "result": { "kor": "결과", "eng": "Result" },
    "mana_gain": { "kor": "마나 회복량", "eng": "Mana gain" },
    "skill_turn": { "kor": "스킬 사용까지 필요 턴", "eng": "Turns required to use skill" },
    "report_suggest": { "kor": "제보&건의", "eng": "Report&Suggest" },
    "view_my": { "kor": "내 글만 보기", "eng": "View my posts" },
    "view_all": { "kor": "전체 보기", "eng": "View All posts" },
    "write": { "kor": "글쓰기", "eng": "Write" },
    "open_reply": { "kor": "답변 보기", "eng": "Open reply" },
    "close_reply": { "kor": "답변 접기", "eng": "Close reply" },
    "writer": { "kor": "작성자", "eng": "Writer" },
    "writer_noname_explain": { "kor": "※미입력 시 [익명]으로 들어갑니다.", "eng": "※If not entered, it will be entered as [Noname]." },
    "title": { "kor": "제목", "eng": "Title" },
    "category": { "kor": "카테고리", "eng": "Category" },
    "content": { "kor": "내용", "eng": "Content" },
    "sumbit": { "kor": "등록", "eng": "Submit" },
    "sumbitting": { "kor": "등록중...", "eng": "Submitting..." },
    "update": { "kor": "수정", "eng": "Update" },
    "team_sharing": { "kor": "조합 공유", "eng": "Team Sharing" },
    "view_my_team": { "kor": "내 조합만 보기", "eng": "View my teams" },
    "share_team": { "kor": "조합 공유하기", "eng": "Share team" },
    "login_explain": { "kor": "로그인 정보를 입력해주세요.", "eng": "Please enter login infos." },
    "simple_join": { "kor": "초간단 회원가입", "eng": "Super simple join" },
    "join_explain": { "kor": "회원가입 정보를 입력해주세요.", "eng": "Please enter join infos." },
    "bad_nickname_explain": { "kor": "※부적절한 닉네임은 제재될 수 있습니다.", "eng": "※Inappropriate nicknames may be subject to sanctions." },
    "id": { "kor": "아이디", "eng": "ID" },
    "nickname": { "kor": "닉네임", "eng": "Nickname" },
    "password": { "kor": "비밀번호", "eng": "Password" },
    "join": { "kor": "가입하기", "eng": "Join" },
    "map": { "kor": "맵", "eng": "Map" },
    "pet": { "kor": "펫", "eng": "Pet" },
    "pet_level": { "kor": "펫 레벨", "eng": "Pet Level" },
    "pet_trait": { "kor": "펫 특성", "eng": "Pet Trait" },
    "pet_select": { "kor": "펫 선택", "eng": "Select Pet" },
    "trait_select1": { "kor": "특성1 선택", "eng": "Select Trait1" },
    "trait_select2": { "kor": "특성2 선택", "eng": "Select Trait2" },
    "trait_select3": { "kor": "특성3 선택", "eng": "Select Trait3" },
    "trait_select4": { "kor": "특성4 선택", "eng": "Select Trait4" },
    "memo": { "kor": "비고", "eng": "Memo" },
    "use_version": { "kor": "사용 버전", "eng": "Use Version" },
    "memo_explain": { "kor": "※모험가 포션 정보, 전복 정도 등 자유롭게 작성", "eng": "※Freely write information about adventurer potions, degree of wipe, etc." },
    "use_version_explain": { "kor": "※최신버전이 기본값으로 들어갑니다.", "eng": "※The latest version is set as default." },
    "adventurer": { "kor": "모험가", "eng": "Adventurer" },
    "adventurer_search_explain": { "kor": "사용법: 모험가(또는 티어), 아이템을 검색하고 빈칸을 클릭하면 적용됩니다. 다시 누르면 지워집니다.", "eng": "Usage: Search for an adventurer (or tier), an item, and click on a blank space to apply. Click again to clear." },
    "adventurer_search_placeholder": { "kor": "티어 숫자 또는 모험가명 검색", "eng": "Search by tier number or adventurer name" },
    "adventurer_select": { "kor": "모험가 선택", "eng": "Select adventurer" },
    "order": { "kor": "순서", "eng": "Order" },
    "wearing_items": { "kor": "착용 아이템", "eng": "Wearing Items" },
    "reset": { "kor": "초기화", "eng": "Reset" },
    "notice": { "kor": "개선내역", "eng": "Notice" },
    "new_regist": { "kor": "신규등록", "eng": "New Regist" },
    "edit": { "kor": "수정", "eng": "Edit" },

    // alert
    "alert_wrong_approach": { "kor": "잘못된 접근입니다.", "eng": "This is the wrong approach." },
    "alert_no_update_perm": { "kor": "수정 권한이 없습니다.", "eng": "No update permission." },
    "alert_map_select": { "kor": "맵을 선택해주세요.", "eng": "Please select map." },
    "alert_exp_per_hour": { "kor": "시간당 획득 경험치를 적어주세요.", "eng": "Please enter [EXP per hour]." },
    "alert_need_login": { "kor": "로그인이 필요합니다.", "eng": "You need login." },
    "alert_id_pw": { "kor": "아이디와 비밀번호를 모두 입력해주세요.", "eng": "Please enter ID and PW." },
    "alert_join_form": { "kor": "가입정보를 모두 입력해주세요.", "eng": "Please enter All of join form." },
    "alert_logout": { "kor": "로그아웃 하시겠습니까?", "eng": "Do you want to logout?" },
  },

}